import axios from "../../axiosInstance"

const Queri_base_api = "/im/ob/import"
 class ImportQuerService {
  
    getImporter(details){
        return axios.post(Queri_base_api+'/getImporter',details);
    }

    getJobFilter(QueryJobfilter){
        return axios.post(Queri_base_api+"/getJobFilter",QueryJobfilter);
    }
    getJobSearch(details){
        return axios.post(Queri_base_api+"/getJobSearch",details)
    }
    getForwarderName(details){
        return axios.post(Queri_base_api+'/getForwarderName',details)
    }
    getConsignmentJobEntryAssign(details){
        return axios.post(Queri_base_api+'/getConsignmentJobEntryAssign',details)
    }
    getCustomHouseCodeForDashBoard(details){
        return axios.post(Queri_base_api+'/getCustomHouseCodeForDashBoard',details)
    }
    insertDuplicateJobImport(details){
        return axios.post(Queri_base_api+'/insertDuplicateJobImport',details)
    }
    getAmendmentCode(){
        return axios.get(Queri_base_api+'/getAmendmentCode')
    }
    insertBeAmendment(details){ 
        return axios.post(Queri_base_api+'/insertBeAmendment',details)
    }
    updateBeAmendment(details){
        return axios.put(Queri_base_api+'/updateBeAmendment',details)
    }
    getBeAmendDetails(details){
        return axios.post(Queri_base_api+'/getBeAmendDetails',details)
    }
}
export default new ImportQuerService();